import { connect } from "react-redux";
import { compose } from "redux";
import { selectIsDevicesLoaded } from "../../../../redux/assets/assetsSelectors";
import { createStructuredSelector } from "reselect";

import WithSpinner from "../../../../components/withSpinner/withSpinner.component";
import DashboardHomeView from "./DashboardHomeView.jsx";

const mapStateToProps = createStructuredSelector({
  isLoading: (state) => !selectIsDevicesLoaded(state),
});

const DashboardHomeContainer = compose(
  connect(mapStateToProps),
  WithSpinner
)(DashboardHomeView);

export default DashboardHomeContainer; 